import { useContext, useState } from 'react';
import DeleteIcon from "src/assets/all-icons/delete-icon.jsx";
import EditArtworkIcon from "src/assets/all-icons/edit-artwork-icon.jsx";
import PlayIcon from "src/assets/all-icons/play-icon.jsx";

import AddToArtlistIcon from '@/assets/all-icons/add-to-artlist-icon';
import ShareIcon from '@/assets/all-icons/share-icon';
import ArtlistDataContext from '@/context/ArtlistDataContext';
import LikeButton from '@/shared-components/buttons/components/LikeButton';
import ThreeDotsIcon from '@/shared-components/icons/components/public/ThreeDotsIcon';

import ArtlistOption from './components/ArtlistOption';
import DeleteArtlist from './components/DeleteArtlist';
import EditArtlistForm from './edit-artlist/edit-artlist-form';
import AddArtworks from './add-artworks';
import TimeSelector from './time-selector';

import './index.css';

export default function Options({ openAddArtworks, setOpenAddArtworks }) {
  const { artlistData, setArtlistData, isCreator } = useContext(ArtlistDataContext);
  const [openOptions, setOpenOptions] = useState(false);
  const [openTimeSelector, setOpenTimeSelector] = useState(false);
  const [openDeleteArtlist, setOpenDeleteArtlist] = useState(false);
  const [openEditArtlist, setOpenEditArtlist] = useState(false);

  function shareArtlist() {
    navigator.share({
      title: `${artlistData.artlist_title}`,
      text: `Take a look at @${artlistData.artlist_creator.user_username}'s artlist: ${artlistData.artlist_title}`,
      url: `https://suarte.art/artlist/${artlistData._id}`
    });
  }

  return (
    <>
      <div className="artlist-options__container">
        {artlistData.artlist_artworks.length > 0 && (
          <PlayIcon 
            className="artlist-options__artlist-play" 
            onClick={() => setOpenTimeSelector(true)}
          />
        )}

        <LikeButton 
          itemId={artlistData._id}
          typeOfItem="ARTLIST"
          isLiked={artlistData.is_liked} 
          className="artlist-options__artlist-like" 
          onLikeAction={(likeStatus) =>
            setArtlistData({
              ...artlistData,
              artlist_likes: likeStatus ? artlistData.artlist_likes + 1 : artlistData.artlist_likes - 1
            })
          }
        />

        {isCreator ? (
          <div 
            tabIndex={0} 
            onClick={() => setOpenOptions(!openOptions)} 
            onBlur={() => setOpenOptions(false)} 
            className="artlist-options__threedots-container"
          >
            <ThreeDotsIcon className="artlist-options__threedots-icon" />

            <ArtlistOption
              text="Add artworks"
              icon={<AddToArtlistIcon className="artlist-options__option-icon" />}
              onClick={() => setOpenAddArtworks(true)}
            />

            <ArtlistOption
              text="Edit artlist"
              icon={<EditArtworkIcon className="artlist-options__option-icon edit" />}
              onClick={() => setOpenEditArtlist(true)}
            />

            <ArtlistOption
              text="Delete artlist"
              icon={<DeleteIcon className="artlist-options__option-icon" />}
              onClick={() => setOpenDeleteArtlist(true)}
            />

            {navigator.share && (
              <ArtlistOption
                text="Share artlist"
                icon={<ShareIcon className="artlist-options__option-icon" />}
                onClick={shareArtlist}
              />
            )}
          </div>
        ) : (
          navigator.share && (
            <ShareIcon 
              className="artlist-options__share-artlist"
              onClick={shareArtlist}
            />
          )
        )}
      </div>

      <TimeSelector 
        open={openTimeSelector} 
        close={() => setOpenTimeSelector(false)}
      />

      <AddArtworks 
        open={openAddArtworks} 
        close={() => setOpenAddArtworks(false)}
      />

      {openEditArtlist && (
        <EditArtlistForm 
          open={openEditArtlist} 
          close={() => setOpenEditArtlist(false)}
        />
      )}

      <DeleteArtlist
        open={openDeleteArtlist} 
        close={() => setOpenDeleteArtlist(false)}
      />
    </>
  );
}
